import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompany = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 5,
			width: 5,
			height: 2,
			rx: 1,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 5,
			width: 5,
			height: 2,
			rx: 1,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 9,
			width: 5,
			height: 2,
			rx: 1,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 9,
			width: 5,
			height: 2,
			rx: 1,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 13,
			width: 5,
			height: 2,
			rx: 1,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 13,
			width: 5,
			height: 2,
			rx: 1,
			fill: "#444444"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 23V19C16 18.4477 15.5523 18 15 18H10C9.44772 18 9 18.4477 9 19V23",
			stroke: "#444444",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 23V3C21 1.89543 20.1046 1 19 1H6C4.89543 1 4 1.89543 4 3V23",
			stroke: "#444444",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgCompany;
